import * as instructorTypes from "Store/instructors/constants";

const initialState: IInstructorsReducer = {
  instructors: [],
  currentInstructor: null,
  isInstructorModalOpen: false,
  isCreateInstructorModalOpen: false,
  queryOptions: {},
  // pagination
  instructorStudents: [],
  instructorSummary: null,
  instructorClassrooms: [],
  instructorsSimplifiedLoading: false
};

const handleActions = (state, action) => {
  switch (action.type) {
    case instructorTypes.SET_INSTRUCTORS:
      return {
        ...state,
        instructors: action.instructors
      };
    case instructorTypes.SET_INSTRUCTOR_SUMMARY:
      return {
        instructorSummary: action.summary
      };

    case instructorTypes.SET_INSTRUCTOR:
      return {
        currentInstructor: action.payload
      };

    case instructorTypes.SET_INSTRUCTOR_STUDENTS:
      return {
        instructorStudents: [...action.payload]
      };
    case instructorTypes.SET_INSTRUCTOR_CLASSROOMS:
      return {
        instructorClassrooms: action.payload
      };
    case instructorTypes.SET_INSTRUCTOR_STATS: {
      const { instructorStats, instructorId } = action.payload;
      return {
        instructors: [
          ...state.instructors.map((instructor) =>
            instructor.id === instructorId ? { ...instructor, ...instructorStats } : instructor
          )
        ]
      };
    }
    case instructorTypes.SET_INSTRUCTORS_SIMPLIFIED_LOADING:
      return {
        instructorsSimplifiedLoading: action.payload.isLoading
      };
    default:
      return {};
  }
};

const instructorReducer = (state = initialState, action) => {
  return {
    ...state,
    ...handleActions(state, action)
  };
};

export default instructorReducer;
